import enMessages from './en.json';
import itMessages from './it.json';
import frMessages from './fr.json';
import deMessages from './de.json';

export const intlMessages = {
	en: enMessages,
	it: itMessages,
	fr: frMessages,
	de: deMessages,
};

export const supportedLanguages = Object.keys(intlMessages);
